// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEvent } from "effector";
import { NboBranchList } from "../../api/backend-openapi";

export const setBranchList = createEvent<NboBranchList>("SET_BRANCH_LIST");
